export default __webpack_public_path__ + "static/media/step1_img1.00abc0f7.png";